import * as React from 'react'

import { Box, Chevron, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface Props {
  onChange?: (year: number) => void
  type: 'negative' | 'terciary' | 'quaternary'
  year: number
  minYear: number
  maxYear: number
}

const YearNavigation = ({ onChange, type, year, minYear, maxYear }: Props) => {
  const onClick = (year: number) => {
    if (!onChange) return null

    return () => onChange(year)
  }

  const previous = year - 1
  const next = year + 1
  const enablePrevious = previous >= minYear
  const enableNext = next <= maxYear

  const previousOnClick = enablePrevious ? onClick(year - 1) : () => null
  const nextOnClick = enableNext ? onClick(year + 1) : () => null

  return (
    <Box flexDirection="row" justifyContent="center" alignItems="center">
      {enablePrevious && (
        <Box cursor="pointer" onClick={() => previousOnClick && previousOnClick()}>
          <Chevron type={enablePrevious ? type : 'quaternary'} direction="left" />
        </Box>
      )}
      <Box paddingX="s16">
        <Text.Normal weight="medium">{year}</Text.Normal>
      </Box>
      {enableNext && (
        <Box cursor="pointer" onClick={() => nextOnClick && nextOnClick()}>
          <Chevron type={enableNext ? type : 'quaternary'} direction="right" />
        </Box>
      )}
    </Box>
  )
}

export default observer(YearNavigation)
